import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { ArrowLeftIcon, LayoutIcon, CodeIcon, SmartphoneIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { buildBreadcrumbList } from '../lib/structuredData';
export const TeamLid3Page: React.FC = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white font-sans text-[#111827]" data-id="element-2519" data-mp="q1u7lzqo62f3">
      <SEO title="Alex, developer | Noord Digital" description="Maak kennis met Alex, developer bij Noord Digital. Hij bouwt de websites die snel laden, goed vindbaar zijn en passen bij de huisstijl van de klant." keywords="alex noord digital, webdeveloper Noord-Holland, wordpress developer" canonical="https://noorddigital.nl/over-ons/alex" jsonLd={buildBreadcrumbList([{
      name: 'Over ons',
      path: '/over-ons'
    }, {
      name: 'Alex',
      path: '/over-ons/alex'
    }])} data-id="element-2520" data-mp="m1jzagfemzx2" />
      <Header data-id="element-2521" data-mp="m1dg7lddgonp" />

      <main className="pt-32 pb-20 lg:pt-40 lg:pb-24" data-id="element-2522" data-mp="m1wveubn0yy1">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2523" data-mp="m3geesooho3i">
          <button onClick={() => navigate('/over-ons')} className="inline-flex items-center gap-2 text-[#004AC7] font-medium hover:underline mb-12" data-id="element-2524" data-mp="r1hyngxubtgk">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-2525" data-mp="1014yvzeu2t81" /> Terug naar het team
          </button>

          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-2526" data-mp="zz21gubcpxta">
            <div className="lg:w-1/3 flex justify-center lg:justify-start" data-id="element-2527" data-mp="14zpypxq6bavy">
              <div className="w-[300px] h-[300px] rounded-full border-4 border-[#004AC7] overflow-hidden shadow-lg" data-id="element-2528" data-mp="19yapz7ng6k89">
                <img src="https://cdn.magicpatterns.com/uploads/gwFh8VhGW156sUNRdzC2Ac/image.png" alt="Alex" className="w-full h-full object-cover" style={{
                objectPosition: 'center 35%'
              }} data-id="element-2529" data-mp="1eqknp9ut0ol3" />
              </div>
            </div>

            <div className="lg:w-2/3" data-id="element-2530" data-mp="1spakeodpom8x">
              <h1 className="text-4xl md:text-5xl font-bold text-[#111827] mb-2" data-id="element-2531" data-mp="1sqbvutyn3ar6">
                Alex
              </h1>
              <p className="text-xl text-[#607697] font-medium mb-8" data-id="element-2532" data-mp="3oqvv6cb96pgn">
                Developer
              </p>

              <div className="prose prose-lg text-[#4B5563] mb-12" data-id="element-2533" data-mp="2ddrgizdturd">
                <p className="mb-4" data-id="element-2534" data-mp="2eouuhox10hy">
                  Als Developer bouw ik de websites en webapplicaties van Noord
                  Digital. Ik vertaal de strategische visie van CorePrint naar
                  snelle, gebruiksvriendelijke en conversiegerichte websites die
                  perfect passen bij de merkidentiteit van onze klanten.
                </p>
                <p className="mb-4" data-id="element-2535" data-mp="lb6urmdx46pa">
                  Mijn focus ligt op het creëren van naadloze
                  gebruikerservaringen (UX) en strakke interfaces (UI). Een
                  website moet er niet alleen fantastisch uitzien, maar ook
                  intuïtief werken op elk apparaat en razendsnel laden.
                </p>
                <p data-id="element-2536" data-mp="2i6mjq68jba93">
                  Ik bouw robuuste, schaalbare oplossingen in WordPress, waarbij
                  ik altijd rekening houd met de nieuwste webstandaarden,
                  toegankelijkheid en technische SEO-vereisten.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-[#111827] mb-6" data-id="element-2537" data-mp="nw4tx3s7vsvl">
                Expertise
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-2538" data-mp="sto7s2l063n0">
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2539" data-mp="ev6l886u2x6o">
                  <LayoutIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2540" data-mp="jw430jnxlp7n" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2541" data-mp="4y22kic75jum">WordPress</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2542" data-mp="9wmzo8w5jneu">
                  <SmartphoneIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2543" data-mp="1zbtiu0p171z1" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2544" data-mp="1zcmjql1b6x99">UI/UX Design</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2545" data-mp="24a4py3nxyydk">
                  <CodeIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2546" data-mp="484wze42pso6" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2547" data-mp="6thi1ewyntp">
                    Frontend Development
                  </h3>
                </div>
              </div>

              <a href="/#contact" className="inline-block bg-[#004AC7] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#003A9E] transition-colors shadow-md" data-id="element-2548" data-mp="3me9twez9z5t0">
                Neem contact op met Alex
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-2549" data-mp="3cmdik286hj6u" />
    </div>;
};